import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as pagesTranslationsActions from "../pageTranslations/actions";
import * as pagesListsActions from "../pagesLists/actions";
import * as fieldCategoriesActions from "../fieldCategories/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";
import moment from "moment";

import Fields from "./fields";

const feature = "fields";

const InitialState = Record({
  fields: new Fields()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function FieldsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.fields
    ) {
      state = state.updateIn(["fields", "entities"], map =>
        map.mergeDeep(action.payload.entities.fields)
      );
    }
  }

  switch (action.type) {
    case actions.PATCH_FIELD + START: {
      return state.setIn(["fields", "loading"], true);
    }
    case actions.PATCH_FIELD + SUCCESS: {
      return state.setIn(["fields", "loading"], false);
    }
    case actions.PATCH_FIELD + ERROR: {
      return state.setIn(["fields", "loading"], false);
    }

    case actions.DELETE_FIELD: {
      return state.deleteIn(["fields", "entities", action.payload.uid]);
    }

    case actions.SET_IS_REMOVE_FIELD_MODAL_VISIBLE: {
      return state.setIn(
        ["fields", "isRemoveModalVisible"],
        action.payload.isOpen
      );
    }

    case actions.SET_IS_ADD_FIELD_MODAL_VISIBLE: {
      return state.setIn(
        ["fields", "isAddModalVisible"],
        action.payload.isOpen
      );
    }

    case actions.MOVE_FIELD: {
      const { dragIndex, hoverIndex } = action.payload;
      const dragIndexSort = state.getIn([
        "fields",
        "entities",
        dragIndex,
        "sort"
      ]);
      const hoverIndexSort = state.getIn([
        "fields",
        "entities",
        hoverIndex,
        "sort"
      ]);
      if (hoverIndexSort > dragIndexSort) {
        state = state.setIn(
          ["fields", "entities", dragIndex, "sort"],
          hoverIndexSort + 5
        );
      } else if (hoverIndexSort < dragIndexSort) {
        state = state.setIn(
          ["fields", "entities", dragIndex, "sort"],
          hoverIndexSort - 5
        );
      } else {
        state = state.setIn(
          ["fields", "entities", dragIndex, "sort"],
          hoverIndexSort
        );
        state = state.setIn(
          ["fields", "entities", hoverIndex, "sort"],
          hoverIndexSort + 5
        );
      }
      return state;
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION: {
      return state.setIn(["fields", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_SUCCESS: {
      let fields = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].fields) {
            let field =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].fields[sectionItem];
            if (field.fieldType === "date") {
              field.value =
                moment(field.value).format("DD.MM.YYYY") !== "Invalid date"
                  ? moment(field.value).format("DD.MM.YYYY")
                  : "";
            }
            fields = fields.set(
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].fields[sectionItem]
                .uid,
              fromJS(field)
            );
          }
        }
      }
      state = state.setIn(["fields", "entities"], fields);
      return state.setIn(["fields", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_ERROR: {
      return state.setIn(["fields", "loading"], false);
    }

    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID: {
      return state.setIn(["fields", "loading"], true);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_SUCCESS: {
      let fields = new Map();
      for (let locale in action.payload.entities.pageTranslations[
        action.payload.result
      ].pageTranslations) {
        for (let section in action.payload.entities.pageTranslations[
          action.payload.result
        ].pageTranslations[locale].sections) {
          for (let sectionItem in action.payload.entities.pageTranslations[
            action.payload.result
          ].pageTranslations[locale].sections[section].fields) {
            let field =
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].fields[sectionItem];
            if (field.fieldType === "date") {
              field.value =
                moment(field.value).format("DD.MM.YYYY") !== "Invalid date"
                  ? moment(field.value).format("DD.MM.YYYY")
                  : "";
            }
            fields = fields.set(
              action.payload.entities.pageTranslations[action.payload.result]
                .pageTranslations[locale].sections[section].fields[sectionItem]
                .uid,
              fromJS(field)
            );
          }
        }
      }
      state = state.setIn(["fields", "entities"], fields);
      return state.setIn(["fields", "loading"], false);
    }
    case pagesTranslationsActions.GET_PAGES_TRANSLATION_BY_UID_ERROR: {
      return state.setIn(["fields", "loading"], false);
    }

    case pagesListsActions.GET_PAGES_LIST_BY_SLUG + START: {
      return state.setIn(["fields", "loading"], true);
    }
    case pagesListsActions.GET_PAGES_LIST_BY_SLUG + SUCCESS: {
      let fields = new Map();
      action.payload.entities.pagesLists[
        action.payload.result
      ].pages.forEach(function(page, pageIndex) {
        page
          .get("pageTranslations")
          .map(function(pageTranslation, pageTranslationIndex) {
            pageTranslation
              .get("sections")
              .map(function(section, sectionIndex) {
                section.get("fields").map(function(field, fieldsIndex) {
                  if (field.get("fieldType") === "date") {
                    field =
                      moment(new Date(field.get("value"))).format(
                        "DD.MM.YYYY"
                      ) !== "Invalid date"
                        ? field.set(
                            "value",
                            moment(new Date(field.get("value"))).format(
                              "DD.MM.YYYY"
                            )
                          )
                        : field.set("value", "");
                  }
                  fields = fields.set(field.get("uid"), field);
                });
              });
          });
        state = state.setIn(["fields", "entities"], fields);
      });
      return state.setIn(["fields", "loading"], false);
    }
    case pagesListsActions.GET_PAGES_LIST_BY_SLUG + ERROR: {
      return state.setIn(["fields", "loading"], false);
    }

    case fieldCategoriesActions.GET_FIELD_CATEGORY + START: {
      return state.setIn(["fields", "loading"], true);
    }
    case fieldCategoriesActions.GET_FIELD_CATEGORY + START: {
      return state.setIn(["fields", "loading"], true);
    }
    case fieldCategoriesActions.GET_FIELD_CATEGORY + SUCCESS: {
      let fields = new Map();
      const fieldCategoryTranslations =
        action.payload.entities.fieldCategories[action.payload.result]
          .fieldCategoryTranslations;
      for (let locale in fieldCategoryTranslations) {
        for (let section in fieldCategoryTranslations[locale].sections) {
          for (let field in fieldCategoryTranslations[locale].sections[section]
            .fields) {
            fields = fields.set(
              fieldCategoryTranslations[locale].sections[section].fields[field]
                .uid,
              fromJS(
                fieldCategoryTranslations[locale].sections[section].fields[
                  field
                ]
              )
            );
          }
        }
      }
      state = state.setIn(["fields", "entities"], fields);
      return state.setIn(["fields", "loading"], false);
    }
    case fieldCategoriesActions.GET_FIELD_CATEGORY + ERROR: {
      return state.setIn(["fields", "loading"], false);
    }
  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/fields/reducer.js